import { toTimestamp, type EpgDate } from '$/epg/dates'
import { type Range } from '$/epg/programs'

export const epgDateToRange = (
  from: EpgDate,
  behind: number,
  ahead: number
): Range => {
  const moment = toTimestamp(from)
  return [moment - behind, moment + ahead]
}
